<script setup lang="ts">
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

export interface TcAlertProps {
  type?: NotificationType;
}

const props = withDefaults(defineProps<TcAlertProps>(), { type: NotificationType.INFO });
</script>

<template>
  <div class="tc-alert" :class="`tc-alert--${props.type}`" border="start">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.tc-alert {
  @include elevation(m);
  @include text.general(low, m);
  @include colors.color(content, high);
  @include sp.padding(false, 4);

  border-radius: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &--info {
    @include colors.bg(content, high);
  }

  &--success {
    @include colors.bg(semantic, success);
  }

  &--error {
    @include colors.bg(semantic, error);
  }
}
</style>
